import {AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild,} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators,} from '@angular/forms';

import {CommmCode} from '../../../../../utils/constante/CommonCode';
import {InscriptionfournisseurFormService} from '../../inscriptionfournisseur-form.service';
import {Fournisseur} from '../../../../../domain/fournisseur/fournisseur';
import {
    isArtisant,
    isEntrpriseEtrangere,
    isGroupeArtisant,
    isPersonnemorale,
    isPersonnePhysique,
} from '../../../../../domain/categorie/common';
import {isEmpty} from '../../../../../utils/is-empty';
import {CustomValidators} from '../../../../../forms/validators';
import {
    SelectCodepostalComponent
} from '../../../../../modules/widget/components/form/select/select-codepostal/select-codepostal.component';
import {SelectCommonComponent} from '../../../../../modules/widget/components/form/select/select-common/select-common.component';
import {FournisseurService} from '../../../../../modules/services/fournisseur/fournisseur.service';

@Component({
    selector: 'app-add-information-generale-fournisseur',
    templateUrl: './add-information-generale-fournisseur.component.html',
    styleUrls: ['./add-information-generale-fournisseur.component.css'],
    providers: [InscriptionfournisseurFormService],
})
// @todo: under test fileds cin &&
export class AddInformationGeneraleFournisseurComponent
    implements OnInit, AfterContentChecked, AfterViewInit {
    formid: FormGroup;
    formemail: FormGroup;

    form = this.formService.createAddForm();
    pays = 'Pays d\'enregistrement';
    @Output() add = new EventEmitter<any>();
    @ViewChild('categorieactivite') categorieactivite;
    @ViewChild('selectCommonComponent')
    selectCommonComponent: SelectCommonComponent;

    @ViewChild(SelectCodepostalComponent) selectCodepostalComponent: SelectCodepostalComponent;
    intValue: String = 'N';
    CommmCode = CommmCode;
    formtype: FormGroup;
    fields = this.formService.fields;
    isPersonnemorale = isPersonnemorale;
    isartisant = isArtisant;
    isPersonnePhysique = isPersonnePhysique;
    isgroupeArisant = isGroupeArtisant;
    isentrprise = isEntrpriseEtrangere;

    constructor(
        private formService: InscriptionfournisseurFormService,
        private cdref: ChangeDetectorRef,
        private f: FormBuilder,
        private service: FournisseurService
    ) {
        this.formid = new FormGroup({
            id: new FormControl('', Validators.required),
            cin: new FormControl(null),
        });
        this.formtype = new FormGroup({
            type: new FormControl('TUN', Validators.required),
        });
        this.formemail = new FormGroup({
            emailreg: new FormControl('', [
                Validators.required,
                CustomValidators.emailValidator(),
            ]),
        });
    }

    get selects() {
        return this.form.get('listCategAct') as FormArray;
    }

    get currentDate() {
        return new Date();
    }

    onSuccess(type?: Fournisseur) {
        if (this.form.valid) {
            this.add.emit(this.form.value);
        } else {
            this.form.markAllAsTouched();
        }
    }

    ngOnInit(): void {
        if (this.formtype.get('type').value == 'TUN') {
            this.form
                .get(this.formService.fields.identifiantunique)
                .setValidators([Validators.required, CustomValidators.ismatricule()]);

            this.form
                .get(this.formService.fields.identifiantunique)
                .setAsyncValidators([
                    CustomValidators.uniqueidentifiantValidator(this.service),
                    CustomValidators.taxExistenceValidtor(this.service),
                ]);
        }
        this.formtype.get('type').valueChanges.subscribe((c) => {
            if (c == 'TUN') {
                this.form.get(this.fields.identifiantunique).setValue(null);
                this.form.get(this.fields.entreprise_entrangere).setValue('N');
                this.form.get(this.fields.Nationalite).setValue('TUN');
                this.form.get(this.formService.fields.categorie).setValue(null);
                this.form
                    .get(this.formService.fields.categorie)
                    .setValidators(Validators.required);
                this.form
                    .get(this.formService.fields.identifiantunique)
                    .setValidators([Validators.required, CustomValidators.ismatricule()]);

                this.form
                    .get(this.formService.fields.identifiantunique)
                    .setAsyncValidators([
                        CustomValidators.uniqueidentifiantValidator(this.service),
                        CustomValidators.taxExistenceValidtor(this.service),
                    ]);
                this.form
                    .get(this.formService.fields.affilation_cnss)
                    .setValidators([
                        Validators.required,
                        CustomValidators.cnssValidtors(),
                    ]);
                this.form
                    .get(this.formService.fields.affilation_cnss)
                    .setAsyncValidators([
                        CustomValidators.uniquecnsstValidator(this.service),
                        CustomValidators.cnssExistenceValidtor(this.service),
                    ]);

                this.form.get(this.fields.Nationalite).clearValidators();
                this.form.updateValueAndValidity();
            } else if (c == 'Autre') {
                this.form.get(this.fields.Nationalite).setValue(null);
                this.form.get(this.fields.identifiantunique).setValue(null);
                this.form.get(this.fields.entreprise_entrangere).setValue('Y');
                this.form.get(this.formService.fields.categorie).setValue('5');
                this.form.get(this.formService.fields.categorie).clearValidators();
                this.form
                    .get(this.fields.Nationalite)
                    .setValidators(Validators.required);
                this.form.get(this.fields.num_unique_artisan).clearValidators();
                this.form.get(this.fields.code_postale).setValue(null);
                this.form
                    .get(this.formService.fields.identifiantunique)
                    .clearValidators();

                this.form
                    .get(this.formService.fields.identifiantunique)
                    .clearAsyncValidators();
                this.form
                    .get(this.formService.fields.identifiantunique)
                    .setValidators([Validators.required]);
                this.form.get(this.fields.adresse).setValue(null);
                this.form.get(this.fields.affilation_cnss).clearAsyncValidators();
                this.form.get(this.fields.affilation_cnss).clearValidators();
                this.selectCodepostalComponent.form.get('gouvernort').setValue(null);
                this.selectCodepostalComponent.form.clearValidators();
                this.form.get(this.fields.code_postale).setValue(null);
                this.form.get(this.fields.adresse).setValue(null);
                this.form.get(this.fields.adresse2).setValue(null);
                this.form.updateValueAndValidity();
            }
        });
        const v = this.form.get(this.formService.fields.entreprise_entrangere)
            .value;
        if (v == 'N') {
            this.form.get(this.formService.fields.adresse).disable();
            this.form.get(this.formService.fields.code_postale).disable();
        }
        this.form.get(this.formService.fields.entreprise_entrangere);
        this.form
            .get(this.formService.fields.entreprise_entrangere)
            .valueChanges.subscribe((x) => {
            if (x == 'Y') {
                this.form.get(this.formService.fields.adresse).enable();
                this.form.get(this.formService.fields.code_postale).enable();
            } else {
                this.form.get(this.formService.fields.adresse).disable();
                this.form.get(this.formService.fields.code_postale).disable();
            }
        });
        this.formid.get('id').valueChanges.subscribe((x) => {
            const list = [];

            x.map((t) => {
                list.push({cd: t});
            });

            this.form.setControl('listCategAct', this.f.array(list));
        });
        this.form.get(this.fields.identifiantunique).valueChanges.subscribe((x) => {
            if (!isEmpty(x)) {
                this.form.get(this.fields.matricule_fiscale).setValue(x);
                this.form.get(this.fields.num_unique_artisan).setValue(x);
            }
        });
        /*   this.form.get(this.fields.categorie).valueChanges.subscribe((x) => {
          this.formid.get("cin").setValue(null);
          this.form.get(this.fields.identifiantunique).setValue(null);
          if (isGroupeArtisant(x)) {
            this.form.get(this.fields.adresse).setValue(null);
            this.form.get(this.fields.entreprise_entrangere).setValue("N");
            /!*        this.form.get(this.fields.affilation_cnss).clearValidators();*!/
            /!*      this.form.get(this.fields.affilation_cnss).clearAsyncValidators();*!/
            this.form
              .get(this.fields.num_unique_artisan)
              .setValidators(Validators.required);
            this.form.get(this.fields.matricule_fiscale).clearValidators();
            /!*    this.form.get(this.fields.matricule_fiscale).clearAsyncValidators();*!/
            /!*    this.form
              .get(this.formService.fields.identifiantunique)
              .clearValidators();
            this.form
              .get(this.formService.fields.identifiantunique)
              .setValidators([Validators.required]);*!/
            this.form.get(this.fields.affilation_cnss).setValidators(null);
            this.form.updateValueAndValidity();
          } else if (isArtisant(x)) {
            this.form.get(this.fields.code_postale).setValue(null);
            this.form.get(this.fields.adresse).setValue(null);
            this.form.get(this.fields.entreprise_entrangere).setValue("N");
            this.form.get(this.fields.affilation_cnss).clearValidators();
            /!*     this.form.get(this.fields.affilation_cnss).clearAsyncValidators();*!/
            /!*    this.form.get(this.fields.matricule_fiscale).clearValidators();
            /!*      this.form.get(this.fields.matricule_fiscale).clearAsyncValidators();*!/
            this.form.get(this.fields.matricule_fiscale).setValidators(null);*!/
            this.form.updateValueAndValidity();
            /!*    this.form
              .get(this.formService.fields.identifiantunique)
              .clearValidators();*!/
            /!*        this.form
              .get(this.formService.fields.identifiantunique)
              .setValidators([Validators.required]);*!/
            this.form.get(this.fields.affilation_cnss).setValidators(null);
          } else if (isPersonnePhysique(x)) {
            this.form.get(this.fields.entreprise_entrangere).setValue("N");
            this.form.get(this.fields.code_postale).setValue(null);
            this.form.get(this.fields.adresse).setValue(null);
            /!*        this.form
              .get(this.fields.matricule_fiscale)
              .setValidators(Validators.required);*!/
            this.form
              .get(this.fields.affilation_cnss)
              .setValidators(Validators.required);
            this.form.get(this.fields.num_unique_artisan).clearValidators();
            /!*       this.formid.get("cin").setValidators(Validators.required);*!/
            this.form.updateValueAndValidity();
          } else if (this.isentrprise(x)) {
            this.form.get(this.fields.num_unique_artisan).clearValidators();
            this.form.get(this.fields.code_postale).setValue(null);
            this.form.get(this.fields.adresse).setValue(null);
            this.form.get(this.fields.affilation_cnss).clearValidators();
            this.selectCodepostalComponent.form.get("gouvernort").setValue(null);
            this.selectCodepostalComponent.form.clearValidators();
            this.form.get(this.fields.code_postale).setValue(null);
            this.form.get(this.fields.adresse).setValue(null);
            this.form.get(this.fields.adresse2).setValue(null);
            this.form.get(this.fields.entreprise_entrangere).setValue("Y");
          } else if (isPersonnemorale(x)) {
            this.form.get(this.fields.code_postale).setValue(null);
            this.form.get(this.fields.adresse).setValue(null);
            this.form.get(this.fields.entreprise_entrangere).setValue("N");
            this.formid.get("cin").clearValidators();
            this.form.get(this.fields.matricule_fiscale).clearValidators();
            /!*        this.form
              .get(this.formService.fields.identifiantunique)
              .clearValidators();
            this.form
              .get(this.formService.fields.identifiantunique)
              .setValidators([Validators.required]);*!/
            this.form
              .get(this.fields.affilation_cnss)
              .setValidators(Validators.required);
            this.form.updateValueAndValidity();
          }
        });
        this.formid.get("cin").valueChanges.subscribe((x) => {
          if (x == "cin") {

            this.form.get(this.fields.identifiantunique).clearValidators();
            this.form.get(this.fields.num_unique_artisan).clearValidators();
            this.form
              .get(this.formService.fields.identifiantunique)
              .setValidators([Validators.required, CustomValidators.isCin()]);
            this.form
              .get(this.formService.fields.matricule_fiscale)
              .setValidators([
                Validators.required,
                CustomValidators.matriculeValidator(),
              ]);
            this.form.updateValueAndValidity();
          }
          if (x == "autre") {
            this.form.get(this.fields.num_unique_artisan).clearValidators();
            this.form.get(this.formService.fields.identifiantunique).setValue(null);
            this.form

              .get(this.formService.fields.identifiantunique)

              .setValidators([Validators.required]);
            this.form.updateValueAndValidity();
          }
        });*/
    }

    get(key: string) {
        return this.form.get(key) as FormControl;
    }

    gettype(key: string) {
        return this.formtype.get(key) as FormControl;
    }

    getFormarray(key: string) {
        return this.form.controls['listCategAct'].get(key) as FormControl;
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngAfterViewInit(): void {
    }

    /*  });*/

    setlable() {
        const value = this.formid.get('cin').value;

        if (value == 'cin' && !isEmpty(value)) {
            return 'N° de CIN';
        }
        if (this.isartisant(this.form.get(this.fields.categorie).value)) {
            return 'Numéro unique de l\'artisan';
        }
        if (this.isPersonnemorale(this.form.get(this.fields.categorie).value)) {
            return 'Matricule fiscal';
        } else {
            return 'Identifiant unique';
        }
    }

    setdate() {
        const value = this.formid.get('cin').value;

        if (
            value == 'cin' &&
            !isEmpty(
                value || this.isartisant(this.form.get(this.fields.categorie).value)
            )
        ) {
            return 'Date de délivrance de carte d\'identité';
        } else {
            return 'Date d\'enregistrement de l\' identifiant unique';
        }
    }
}
